import { SearchModalInput } from './SearchModalInput'
import { SearchModalResults } from './SearchModalResults'
import { ListingSearchProvider } from '../../../../context/listingSearch'

import styles from './SearchModal.module.scss'

export const SearchModal = () => (
  <ListingSearchProvider>
    <div className={styles.container} data-qa='search-modal'>
      <SearchModalInput />
      <SearchModalResults />
    </div>
  </ListingSearchProvider>
)
